// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inline-absolute {
  margin-left: 24px;
}

span.CcmListItemTextOverflow.CcmListItemName {
  position: relative;
}

.tooltip-wrapper,
fi-info-icon {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/statistic2/statistic2-report-view/statistic2-report-value-header/statistic2-report-value-header.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;;EAEI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;AACJ","sourcesContent":[".inline-absolute {\r\n    margin-left: 24px;\r\n}\r\n\r\nspan.CcmListItemTextOverflow.CcmListItemName {\r\n    position: relative;\r\n}\r\n\r\n.tooltip-wrapper,\r\nfi-info-icon {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
